import $http from './http'
import config from './config'

export default {
    name: 'storage',
    getUrl(url) {
        return config.getUrl(this.name, url);
    },
    getUploadImg(data,id,type){
        return $http.post(this.getUrl(`/upload/${type}/${id}`),data,{failTips:false});
    },
 
}    


// WEBPACK FOOTER //
// ./src/apis/storageApis.js